import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.map.js";
import { __decorate } from "tslib";
import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import PicUpload from "@/components/picUpload/index.vue";
let onlineBooking = class onlineBooking extends Vue {
  constructor() {
    super(...arguments);
    this.answer = "";
  }
  dataChage(value) {
    this.zItem = value;
    if (this.viewMode == "ANSWERREVIEW") {
      if (value.answer) {
        this.answer = value.answer.map(item => {
          const dateAndHourly = item.split("_");
          const reservation = {
            date: dateAndHourly[0]
          };
          if (dateAndHourly.length > 1) reservation.hourly = dateAndHourly[1] + " - " + dateAndHourly[2];
          return reservation;
        });
      }
    }
  }
  weekDays(day) {
    const date = new Date(day);
    const weekDays = ["周日", "周一", "周二", "周三", "周四", "周五", "周六"];
    return weekDays[date.getDay()];
  }
};
__decorate([Prop({
  type: String,
  default: "EDIT"
})], onlineBooking.prototype, "viewMode", void 0);
__decorate([Prop({
  type: Object,
  default: {}
})], onlineBooking.prototype, "item", void 0);
__decorate([Prop({
  type: Number,
  default: 0
})], onlineBooking.prototype, "zIndex", void 0);
__decorate([Prop({
  type: Boolean,
  default: true
})], onlineBooking.prototype, "Required", void 0);
__decorate([Watch("zIndex", {
  immediate: true
}), Watch("item", {
  immediate: true,
  deep: true
})], onlineBooking.prototype, "dataChage", null);
onlineBooking = __decorate([Component({
  name: "onlineBooking",
  components: {
    PicUpload
  }
})], onlineBooking);
export default onlineBooking;